import React from 'react';

const getRejection = (input = "") => {
  const description = input.split("Rejection Reason:")[0].trim() || "";
  const rejection = (input.match(/Rejection Reason: (.*?)(?=\n|$)/g) || []).pop()?.replace("Rejection Reason: ", "").trim() || "";
  return { description, rejection };
};

const RejectionModal = ({ isOpen, onClose, adData }) => {
  if (!isOpen) return null;

  // Extract description and rejection from adData.rough_description
  const { description, rejection } = getRejection(adData?.rough_description || "");

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{adData.creative_name}</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {/* Description */}
        <div className="mb-4">
          <p className="text-gray-700 mb-2 font-semibold">Description:</p>
          <pre className="whitespace-pre-wrap break-words font-mono bg-gray-100 p-3 rounded-md">
            {description || 'No description available.'}
          </pre>
        </div>
        
        {/* Rejection Reason */}
        {rejection ? (
          <div className="border rounded-lg p-3 mt-4 bg-red-100">
            <p className="font-bold text-red-600 mb-1">Rejection Reason:</p>
            <p>{rejection}</p>
          </div>
        ) : (
          <p className="text-gray-500 italic">No rejection reason provided.</p>
        )}

        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectionModal;
